// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cd9452b6","732":"64d986f1","977":"73a82925"}[chunkId] + ".chunk.js";
};